import { Zero } from "@rocicorp/zero";

import { refreshAuthFn } from "@/features/auth/server-functions/check-auth";

import { createMutators } from "./mutators";
import { schema } from "./server/zero-schema";

export function initZero(userId: string, accessToken: string) {
  return new Zero({
    userID: userId,
    auth: async (error) => {
      if (error === "invalid-token") {
        const { accessToken } = await refreshAuthFn();
        return accessToken;
      }
      return accessToken;
    },
    server: import.meta.env.VITE_PUBLIC_SERVER,
    schema,
    mutators: createMutators({ sub: userId }),
    kvStore: typeof window !== "undefined" ? "idb" : "mem",
  });
}
